import { LocalStorageKey } from 'shared/constants/localStorage'
import { lsGetItem } from 'shared/utils/local-storage'

import { middlewareController } from '../middlewareController'
import { setHasOutdatedToken } from './tokenState'

export const authApi = middlewareController.create.axiosInstance({
  baseURL: process.env.REACT_APP_AUTH_ENDPOINT!
})

authApi.interceptors.request.use(config => {
  setHasOutdatedToken(
    config.headers.Authorization?.toString().split('Bearer ')[1] !==
      lsGetItem(LocalStorageKey.USER)?.access_token
  )
  return config
})
